import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/snippets/pb-shop-equivalents/pb-shop-equivalents.ts
var PbShopEquivalents = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.startX = 0;
    this.startScroll = 0;
    this.dragging = false;
    this.moved = false;
  }
  connectedCallback() {
    if (this.fadeContainer) {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.updateScrollFade(this.fadeContainer);
      this.fadeContainer.addEventListener("scroll", () => this.updateScrollFade(this.fadeContainer));
      window.addEventListener("resize", () => this.updateScrollFade(this.fadeContainer));
      this.fadeContainer.addEventListener("mousedown", (element) => {
        element.preventDefault();
        this.dragging = true;
        this.moved = false;
        this.startX = element.clientX;
        this.startScroll = this.fadeContainer.scrollLeft;
      }, { signal });
      this.fadeContainer.addEventListener("click", (e) => {
        if (this.moved) {
          e.preventDefault();
          e.stopPropagation();
        }
        this.moved = false;
      }, { capture: true, signal });
      window.addEventListener("mousemove", (element) => {
        if (!this.dragging)
          return;
        const dx = element.clientX - this.startX;
        if (Math.abs(dx) > 5)
          this.moved = true;
        this.fadeContainer.scrollLeft = this.startScroll - dx;
      }, { signal });
      window.addEventListener("mouseup", () => {
        this.dragging = false;
      }, { signal });
    }
  }
  updateScrollFade(container) {
    const hasOverflow = container.scrollWidth > container.clientWidth;
    const atStart = container.scrollLeft <= 0;
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    container.classList.toggle("fade-left", hasOverflow && !atStart);
    container.classList.toggle("fade-right", hasOverflow && !atEnd);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.abort) == null ? void 0 : _a.abort();
  }
};
__decorateClass([
  query("[equivalent-fade-container]")
], PbShopEquivalents.prototype, "fadeContainer", 2);
PbShopEquivalents = __decorateClass([
  defineElement("pb-shop-equivalents")
], PbShopEquivalents);
export {
  PbShopEquivalents
};
